import React, { useEffect, useState } from 'react'
import { Button, Backdrop, useTheme, Typography, Alert } from '@mui/material'
import TvIcon from '@mui/icons-material/Tv';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../auth/hooks/useAuthContext';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import { socket } from '../../../config/SocketApi';

const SelectSreenShare = ({ room_id }) => {
    const { user } = useAuthContext() || JSON.parse(localStorage.getItem("user"));
    const [screenSources, setScreenSources] = useState(false)
    const [showDesktopWarning, setShowDesktopWarning] = useState(false)
    const { meetingStarted } = useSelector((store) => store.meeting)
    const [sessionStarted, setSessionStarted] = useState(false)
    const theme = useTheme();
    const { t } = useTranslation();
    const hasElectronMethod = (methodName) => typeof window !== 'undefined' && window.electron && typeof window.electron[methodName] === 'function';
    const handleSetScreen = (screenId) => {
        if (!hasElectronMethod('shareScreen')) {
            setShowDesktopWarning(true);
            return;
        }
        window.electron.shareScreen(screenId, room_id);
        setScreenSources(false)
    }
    const chooseDisplay = async () => {
        if (!hasElectronMethod('getSources')) {
            setShowDesktopWarning(true);
            return;
        }
        
        try {
            const sources = await window.electron.getSources();
            if (sources.length === 1) { handleSetScreen(sources[0]?.display_id) } else { setScreenSources(sources); }

        } catch (error) {
            console.log("error happened when getting display sources ", error)
        }

    }
    useEffect(() => {
        socket.on("teacher-started-session-header", () => {
            setSessionStarted(true)
        })
        return () => {
            socket.off("teacher-started-session-header");
        }
    }, [])
    if (meetingStarted || !sessionStarted) {
        return null
    } else {
        return (
            <>
                {/* Warning dialog for non-Electron browsers */}
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={showDesktopWarning}
                    onClick={() => setShowDesktopWarning(false)}
                >
                    <Box sx={{ backgroundColor: theme.palette.background.default, display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center', justifyContent: 'space-around', padding: '3rem', borderRadius: 2, maxWidth: 400 }}>
                        <Alert severity="info" sx={{ width: '100%' }}>
                            {t("screenShareDesktopOnly") || "Screen sharing requires the desktop app. Please use Ropera Virtual Desktop for screen sharing."}
                        </Alert>
                        <Button variant="outlined"
                            sx={{
                                color: theme.palette.secondary.main,
                                borderColor: theme.palette.secondary.main,
                            }} onClick={() => setShowDesktopWarning(false)}>{t("close")}</Button>
                    </Box>
                </Backdrop>
                
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={screenSources}
                >
                    <Box sx={{ backgroundColor: theme.palette.background.default, display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center', justifyContent: 'space-around', padding: '5rem' }}>
                        <Typography sx={{ color: theme.palette.text.secondary }}>{t("chooseAScreen")}</Typography>
                        <Box sx={{ borderRadius: '10px', display: 'flex', flexDirection: 'row' }}>
                            {screenSources && screenSources.map((screen, index) =>
                                <Box key={index} sx={{ ":hover": { border: `1px solid ${theme.palette.primary.main}`, backgroundColor: theme.palette.primary.main }, borderRadius: '5px', margin: '1rem' }} >
                                    <img height={100} src={screen.thumbnail} onClick={() => handleSetScreen(screen.display_id)} alt={screen.name}
                                        style={{ width: '150px', margin: '10px' }} />
                                </Box>)}

                        </Box>
                        <Button variant="outlined"
                            sx={{
                                color: theme.palette.secondary.main,
                                borderColor: theme.palette.secondary.main,
                            }} onClick={() => setScreenSources(false)}>{t("close")}</Button>
                    </Box>

                </Backdrop>
                <Button onClick={() =>
                    chooseDisplay()
                }
                    variant="outlined"
                    sx={{
                        pr: theme.direction === "rtl" ? '0px' : '10px',
                        color: theme.palette.secondary.main,
                        borderColor: theme.palette.secondary.main,
                        display: user?.user_type !== 0 ? 'inline-flex' : 'none'
                    }}
                    startIcon={<TvIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
                    {t("share_screen")}
                </Button>
            </>

        )
    }

}

export default SelectSreenShare
